export default {
	WEB: 'web',
	REACT_NATIVE: 'native',
	ANDROID: 'android',
	EXTERNAL: 'external',
}
